import graph from "@irati/utils/services/graph";
import { toString as ScheduledTransfersQuery } from "./query/ScheduledTransferList";
var service = {
    list: function (walletOwnerId, walletId, scheduledTransferStatus, cursor, limit, options) {
        if (cursor === void 0) { cursor = null; }
        if (limit === void 0) { limit = 15; }
        if (options === void 0) { options = {}; }
        return graph({ query: ScheduledTransfersQuery, variables: { walletOwnerId: walletOwnerId, walletId: walletId, scheduledTransferStatus: scheduledTransferStatus, cursor: cursor, limit: limit } }, options).then(function (response) { return response.scheduledTransfers; });
    }
};
export var getScheduledTransfers = service.list;
